import { render, staticRenderFns } from "./UnipileChannelStatusBadge.vue?vue&type=template&id=1421f9af&scoped=true"
import script from "./UnipileChannelStatusBadge.vue?vue&type=script&lang=js"
export * from "./UnipileChannelStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./UnipileChannelStatusBadge.vue?vue&type=style&index=0&id=1421f9af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1421f9af",
  null
  
)

export default component.exports